import { CategorySummaryDTO } from '../admin-api';

export class CategoryUtil {
  static expandToList(
    category: CategorySummaryDTO,
    categoryIdFilter?: number,
    array?: CategorySummaryDTO[]
  ) {
    if (!array) array = [];
    if (!categoryIdFilter || category.categoryId !== categoryIdFilter) {
      array.push(category);
      category.subcategoriesList?.forEach((sc) =>
        this.expandToList(sc, categoryIdFilter, array)
      );
    }
    return array;
  }
}
